import axios from "axios";

export default axios.create({
	baseURL: "https://lib-app-backend.herokuapp.com/api/",
	headers: {
		"Content-type": "application/json"
	}
});